export default __webpack_public_path__ + "fonts/whats-img1.svg";